import React, { Component } from "react";
import Releases from "./release-list";
import NewRelease from "./newrelease";
import * as firebase from "firebase";
import "./App.css";

let config = {
  apiKey: "AIzaSyA5-B88oHCZKdDubpDb8wohwjlppJ8HLcc",
  authDomain: "approximate-2ddaf.firebaseapp.com",
  databaseURL: "https://approximate-2ddaf.firebaseio.com",
  projectId: "approximate-2ddaf",
  storageBucket: "approximate-2ddaf.appspot.com",
  messagingSenderId: "775530548830"
};

firebase.initializeApp(config);

//???

class Home extends Component {
  constructor(props) {
    super(props);

    //Database refs
    this.chatRef = firebase.database().ref().child("chat");
    this.releasesRef = firebase.database().ref().child("releases");
    this.contactRef = firebase.database().ref().child("contact");

    this.addChat = this.addChat.bind(this);

    this.state = {
      releases: [],
      selectedRelease: null,
      contacts: [],
      chatPosts: []
    };
  }

  componentDidMount() {
    const previousChatPosts = this.state.chatPosts;

  

    this.releasesRef.once("value", snap => {
      this.setState({
        releases: snap.val(),
        selectedRelease: snap.val()[0],
      });
    }).then(function(){
      //FIX
    });


    //Fetch data and listen for changes
    this.chatRef.limitToLast(4).on("child_added", snap => {
     
        //add new fetched data to previousChatPosts array
        previousChatPosts.push({
        timestamp: snap.val().timestamp,
        id: snap.key,
        chatContent: snap.val().chatContent,
        handle: snap.val().handle
      });
 
      //set the state to the updated data
      this.setState({
        chatPosts: previousChatPosts.slice(-4)
      });
    });
  }

  addChat(message, handle) {
      //push new chatmessage to firebase db.
    this.chatRef.push().set({
          timestamp: new Date().getTime(),
          handle: handle,
          chatContent: message
        },
        function(error) {
          if (error) {
            console.log("Data could not be saved." + error);
          } else {
            console.log("Data saved successfully.");
          }
        }
      );
  }

  render() {
    return (
      <div id="superWrapper">
        <div className="wrapper">
        <NewRelease 
          onLiveLinkSelect={selectedVideoLink =>
            this.setState({
              selectedRelease: {
                ...this.state.selectedRelease,
                videoUrl: selectedVideoLink
              }
            })}
          release={this.state.selectedRelease}
          
        />
        </div>
        <Releases
         // addChat={this.addChat}
          onReleaseSelect={selectedRelease =>
            this.setState({ selectedRelease: selectedRelease })}
          releases={this.state.releases}
          chatPosts={this.state.chatPosts}
        />
      </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/home.js